// @flow
import React from 'react';

import { Hero, type Props as HeroProps } from 'Components/widgets/hero/Hero.jsx';

type Props = {
  ...$Exact<HeroProps>,
  backgroundURL: string,
  id?: string,
};

export function HighlightLine({ backgroundURL, ...props }: Props) {
  return (
    <Hero
      {...props}
      className="Line Line-Highlight"
      size="highlight"
      trackingData={{ actionGA: 'highlight' }}
      url={backgroundURL}
    />
  );
}
